import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ProcessingOrders } from 'src/app/models/supplier-portal/supplier/supplierOrdersProcessing.models';
import { OrderHelperService } from 'src/app/services/portal-supplier/order-helper.service';

@Component({
  selector: 'app-check-order-articles',
  standalone: false,
  templateUrl: './check-order-articles.component.html',
  styleUrls: ['./check-order-articles.component.scss'],
})

export class CheckOrderArticlesComponent implements OnInit {
  @Input({ required: true })
  @Input() products: ProcessingOrders.IProductInOrder[] = [];
  @Input() public selectedCode = -1;
  @Input() public processedCodes: number[] = [];
  @Input() public completed = false;
  actionLabel = 'AGGIUNGI LOTTO';
  hasBatchLabel = 'ELABORA LOTTO'

  @Output()
  public readonly articleSelected =
    new EventEmitter<ProcessingOrders.IProductInOrder>();
  @Output() public readonly articleAction = new EventEmitter<number>();
  @Output() public readonly openLot = new EventEmitter<number>();
  @Input() orderId!: number;
  public orderService = inject(OrderHelperService);

  public newBatchToUpload: ProcessingOrders.IProductBatch | null = null;

  ngOnInit(): void {
    console.log('Articles in CheckOrderArticlesComponent', this.products);

  }
  public isSelected(code: number, product: ProcessingOrders.IProductInOrder): boolean {
    return (
      !this.completed && this.selectedCode === code && !this.isProcessed(product)
    );
  }

  public isProcessed(product: ProcessingOrders.IProductInOrder): boolean {
    return this.completed || product.is_prepared;
  }

  public showAction(hasBatches: number = 0): boolean {
    return !this.completed && (hasBatches === 0);
  }

  public showCompletedIcon(product: ProcessingOrders.IProductInOrder): boolean {
    return this.isProcessed(product);
  }

  public triggerAction(code: number, event: Event): void {
    event.stopPropagation();
    this.articleAction.emit(code);
    console.log('adding batch and range', code, event);
  }

  public triggerAction2(code: number, event: Event): void {
    event.stopPropagation();
    this.openLot.emit(code);
    console.log('reviewing batches', code, event);
  }
}
